import React, { useEffect } from "react";

import useState from "react-usestateref";

import Pagination from "@material-ui/lab/Pagination";
import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@material-ui/core";
import useStyles from "../components/Header/styles";
import apiService from "../core/service/detail";
import { RxCrossCircled } from "react-icons/rx";
import { getMethod } from "../core/service/common.api";
import { postMethod } from "../core/service/common.api";
import moment from "moment";
import SearchBar from "./searchbar";
import * as Icons from "@material-ui/icons";
import Skeleton from "react-skeleton-loader";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import FromDatePicker from "./fromdatepicker";
import ToDatePicker from "./todatepicker";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "none",
  outline: "none",
  boxShadow: 24,
  borderRadius: "10px",
  // p: 4,
};

function Contact() {
  const [currentPage, setCurrentPage] = useState(1);
  const [contacts, setgetcontacts, contactsref] = useState([]);
  const [totalPage, setTotalpages] = useState(0);
  var classes = useStyles();

  const recordPerPage = 10;
  // total number of the records
  const totalRecords = 15;
  // range of pages in paginator
  const pageRange = 5;

  const [open, setOpen] = useState(false);
  const [viewcontact, setviewcontact] = useState("");
  const [pageloader, setpageloader] = useState(true);
  const [activefilter, setActivefilter] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [toDate, setToDate] = useState("");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [validopen, setvalidOpen] = useState(false);

  const handlevalidOpen = () => setvalidOpen(true);
  const handlevalidClose = () => setvalidOpen(false);

  const handlePageChange = (pageNumber) => {
    getContacts(pageNumber);
    setCurrentPage(pageNumber);
    // setchoosepage()
  };

  useEffect(() => {
    getContacts();
  }, []);

  const getContacts = async (page, search = searchTerm) => {
    try {
      var payload = {
        perpage: 10,
        page: page,
        search: search,
        fromDate: fromDate,
        toDate: toDate,
      };
      var data = {
        apiUrl: apiService.get_Blocksentels_blog_contacts,
        payload: payload,
      };
      setpageloader(true);
      var resp = await postMethod(data);
      setpageloader(false);
      if (resp.status) {
        console.log(resp.data.data, "resp.data.data");
        setgetcontacts(resp.data.data);
        setTotalpages(resp.data.pages);
      }
    } catch (error) {}
  };

  const handleExportBeleafContacts = async () => {
    try {
      if (!activefilter) {
        const response = await postMethod({
          apiUrl: apiService.exportBeleafContactList,
          payload: {},
        });

        if (response.success && response.data) {
          const data = response.data;
          console.log(data, "data===");

          const formattedData = data.map((item, index) => ({
            Name: item.name || "-",
            Email: item.email || "-",
            Mobile: item.mobileNumber || "-",
            Comments: item.comments || "-",
            Country: item.country || "-",
            "Created Date": item.createdAt
              ? new Date(item.createdAt).toLocaleString()
              : "-",
          }));

          const worksheet = XLSX.utils.json_to_sheet(formattedData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Course Contacts");

          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          saveAs(blob, "Blocksentinals Blog Contacts.xlsx");
        } else {
          alert("No data available for export.");
        }
      } else {
        if (contactsref && contactsref.current.length > 0) {
          const data = contactsref.current;

          const formattedData = data.map((item, index) => ({
            Name: item.name || "-",
            Email: item.email || "-",
            Mobile: item.mobileNumber || "-",
            Comments: item.comments || "-",
            Country: item.country || "-",
            "Created Date": item.createdAt
              ? new Date(item.createdAt).toLocaleString()
              : "-",
          }));

          const worksheet = XLSX.utils.json_to_sheet(formattedData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Course Contacts");

          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          saveAs(blob, "Blocksentinals Blog Contacts.xlsx");
        } else {
          alert("No data available for export.");
        }
      }
    } catch (error) {
      console.error("Export failed", error);
      alert("Failed to export Job Applyer List.");
    }
  };
  const handleFilterchange = async (e) => {
    setActivefilter(true);
    await getContacts(1);
  };

  const enquiry = async (e) => {
    try {
      var payload = {
        _id: e._id,
        status: "read",
      };
      var data = {
        apiUrl: apiService.changestatus,
        payload: payload,
      };

      var resp = await postMethod(data);
      if (resp.status) {
        getContacts();
      } else {
      }
    } catch (error) {
      console.log("=-=-=-=-=-=-=-=-", error, "=-=-=-=-=-error-=-=");
    }
  };
  const changeStatus = async (value) => {
    var payload = {
      _id: viewcontact._id,
      status: value,
    };
    var data = {
      apiUrl: apiService.changeblockblogContactstatus,
      payload: payload,
    };

    var resp = await postMethod(data);
    if (resp.success == true) {
      toast.success(resp.message);
      getContacts();
      handlevalidClose();
    } else {
      toast.error(resp.message);
    }
  };
  return (
    <>
      <div>
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
          <Typography
            fullWidth
            color="inherit"
            className={classes.blog_categories}
            variant="body2"
            sx={{ mt: 1 }}
          >
            Blocksentinals Blog Contact
          </Typography>
          <div className="right_top">
            <SearchBar
              placeholder="Search by Name"
              className="mb-3"
              onSearch={(term) => {
                setSearchTerm(term);
              }}
            />

            <FromDatePicker
              placeholder="DD-MM-YYYY"
              onSearch={(date) => setFromDate(date)}
            />

            <ToDatePicker
              placeholder="DD-MM-YYYY"
              fromDate={fromDate}
              onSearch={(date) => setToDate(date)}
            />

            <div className="btn_add" onClick={() => handleFilterchange()}>
              <span>Filter</span>
              <Icons.FilterListSharp />
            </div>
            <Button
              className={classes.btn_export}
              variant="outlined"
              color="primary"
              onClick={handleExportBeleafContacts}
            >
              <i class="fas fa-file-excel"></i> Export
            </Button>
          </div>
        </div>
        <div className="table_outer">
          <div className="table-responsive">
            <table class="table m-0 table-striped">
              <thead className="admin_thead">
                <tr>
                  <th> S.No</th>
                  <th> Name </th>
                  <th> Email</th>
                  <th> Mobile Number</th>
                  <th> Message </th>
                  <th> Country </th>
                  <th> Date </th>
                  <th> Status </th>
                  <th> Validity Status </th>
                  <th> View </th>
                </tr>
              </thead>

              <tbody className="admin_tbody">
                {pageloader === true ? (
                  Array.from({ length: 10 }).map((_, i) => (
                    <tr key={i}>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                      <td>
                        <Skeleton />
                      </td>
                    </tr>
                  ))
                ) : contactsref.current.length > 0 ? (
                  contactsref.current &&
                  contactsref.current.map((orders, i) => {
                    return (
                      <tr>
                        <td>{i + 1}</td>
                        <td>{orders.name}</td>
                        <td>{orders.email}</td>
                        <td>{orders.mobileNumber}</td>
                        <td>{orders.comments}</td>
                        <td>{orders.country}</td>
                        <td>{moment(orders.createdAt).format("lll")}</td>

                        <td>
                          {orders.readStatus == "notread" ? (
                            <p
                              className="mb-0"
                              style={{ color: "green" }}
                              onClick={() => enquiry(orders)}
                            >
                              {" "}
                              Open{" "}
                            </p>
                          ) : (
                            <p className="mb-0" style={{ color: "red" }}>
                              {" "}
                              Closed{" "}
                            </p>
                          )}
                        </td>
                        <td>
                          {orders.contactStatus === "active" ? (
                            <p
                              className="mb-0 cursor-pointer btn_add btn_activechange"
                              style={{ color: "white", Cursor: "pointer" }}
                              onClick={() => {
                                handlevalidOpen();
                                setviewcontact(orders);
                              }}
                            >
                              Active
                            </p>
                          ) : orders.contactStatus === "Valid" ? (
                            <p
                              className="mb-0"
                              style={{ color: "green", cursor: "not-allowed",textAlign:'center' }}
                            >
                              Valid
                            </p>
                          ) : (
                            <p
                              className="mb-0"
                              style={{ color: "red", cursor: "not-allowed",textAlign:'center' }}
                            >
                              Invalid
                            </p>
                          )}
                        </td>
                        <td
                          onClick={() => {
                            handleOpen();
                            setviewcontact(orders);
                          }}
                          className="cursor-pointer"
                        >
                          <i class="fa-solid fa-eye cursor-pointer" />
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr className="no-record">
                    <td colSpan={10}>
                      <div className="emptyrecordimg">
                        <img
                          src={require("../images/No-data.webp")}
                          width="100px"
                        />
                        <span className="emptyrecord">No records found</span>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {totalPage > 1 && (
          <Pagination
            count={totalPage}
            page={currentPage}
            onChange={(e, value) => handlePageChange(value)}
            className={`${classes.blog_pagination} mt-4`}
            color="primary"
            shape="rounded"
          />
        )}
   <Modal
          open={validopen}
          onClose={handlevalidClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="modal_close_icon_valid2">
              <RxCrossCircled
                className="modal_close_icon_valid"
                onClick={handlevalidClose}
              />
            </div>
            <h5 className="logout_title mt-4"> Notification</h5>

            <p className="logout_content">
              Hi, please confirm whether this contact is valid or invalid.
            </p>
            <div className="logout_btn_wrapper p-3">
              <button
                className="logout_confirm custom_btn2 text-center"
                onClick={() => changeStatus("Valid")}
              >
                Valid
              </button>
              <button
                className="logout_cancel custom_btn2 text-center"
                onClick={() => changeStatus("Invalid")}
              >
                Invalid
              </button>
            </div>
          </Box>
        </Modal>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="modal_top">
              <h5>Contact Information</h5>
              <RxCrossCircled
                className="modal_close_icon"
                onClick={handleClose}
              />
            </div>
            <div className="modal_bottom">
              <div className="modal_details">
                <h6>Name</h6>
                <p>{viewcontact.name ? viewcontact.name : "--"}</p>
              </div>
              <div className="modal_details">
                <h6>Email</h6>
                <p>{viewcontact.email ? viewcontact.email : "--"}</p>
              </div>
              <div className="modal_details">
                <h6>Mobile Number</h6>
                <p>
                  {viewcontact.mobileNumber ? viewcontact.mobileNumber : "--"}
                </p>
              </div>
              <div className="modal_details">
                <h6>Country</h6>
                <p>
                  {viewcontact.userCountry ? viewcontact.userCountry : "--"}
                </p>
              </div>
              <div className="modal_details">
                <h6>Message</h6>
                <p>{viewcontact.comments ? viewcontact.comments : "--"}</p>
              </div>
            </div>
            <div className="d-flex"></div>
          </Box>
        </Modal>
      </div>
    </>
  );
}

export default Contact;
